import { Pipe, PipeTransform } from "@angular/core";
import { map } from "rxjs/operators";
import { Connote } from "src/app/model/dispatch.model";
import { ConnoteService } from "src/app/services/connote.service";

@Pipe({
  name: 'connoteControlNo$'
})
export class ConnoteControlNoPipe implements PipeTransform {
  public constructor(private service: ConnoteService) { }

  /**
   * Transform the given connote by its id to its control number.
   * @param id Connote id.
   * @returns Connote control number.
   */
  public transform(id: Connote['id']) {
    return this.service
      .getConnote(id)
      .pipe(
        map((connote) => connote.control_no)
      );
  }
}
